import { createTheme, type MantineThemeOverride } from '@mantine/core'

export const SeenMantineTheme: MantineThemeOverride = createTheme({
  colors: {
    pine: [
      '#edf7f3',
      '#cae7db',
      '#a7d7c3',
      '#84c7ab',
      '#61b793',
      '#489e7a',
      '#387b5f',
      '#285844',
      '#183529',
      '#08120e',
    ] as const,
    teal: [
      '#F1FAFA',
      '#E2F4F4',
      '#C4E8E8',
      '#9CD8D9',
      '#58BEBF',
      '#3E9FA1',
      '#328183',
      '#286769',
      '#205253',
      '#1a4444',
      '#0f2626',
    ] as const,
    charcoal: [
      '#f8f9f9',
      '#e1e3e5',
      '#caced1',
      '#b3b8bd',
      '#9ca3a9',
      '#858d95',
      '#343a40',
      '#2a2f34',
      '#1f2328',
      '#15181c',
    ] as const,
    persimmon: [
      '#ffece4',
      '#ffd7cd',
      '#ffae9a',
      '#ff8163',
      '#ff5c36',
      '#ff4418',
      '#ff3807',
      '#e42900',
      '#cc2100',
      '#b21500',
    ],
  },
  primaryColor: 'teal',
  fontSizes: {
    xxs: '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '3xl': '1.5rem',
  },
})
